import { useQuery } from "@tanstack/react-query";
import postsMediaAPI from "../../api/posts-media/api";

export function getQueryKey(postId: string | number) {
  return ["posts-media", "post", postId];
}

export function useGetPostsMediaByPostId(postId: string | number) {
  return useQuery({
    queryKey: getQueryKey(postId),
    queryFn: () => postsMediaAPI.getPostsMediaByPostId(postId),
    enabled: !!postId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
